var _circle, _circle2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_2489_10491)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0497 11.265L20.3281 8.02431C20.2309 7.9919 20.129 7.9919 20.0364 8.02431L10.3148 11.265C10.125 11.3299 10 11.5058 10 11.7048V19.6488C10 25.8058 14.134 31.2918 20.0597 32.9815C20.1013 32.9954 20.143 33 20.1847 33C20.2263 33 20.268 32.9954 20.3097 32.9815C26.2306 31.2918 30.3694 25.8058 30.3694 19.6488V11.7048C30.3694 11.5058 30.2397 11.3299 30.0546 11.265H30.0497ZM29.4386 19.6489C29.4386 25.3524 25.6379 30.4354 20.1798 32.0558C14.7217 30.4355 10.921 25.3524 10.921 19.6489V12.038L20.1798 8.95019L29.4386 12.038V19.6489Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 10.954L13.0873 13.2687C12.8975 13.3335 12.7725 13.5094 12.7725 13.7085V19.6481C12.7725 24.2636 15.6844 28.4441 20.0175 30.0503C20.0684 30.0688 20.1239 30.078 20.1795 30.078C20.235 30.078 20.2906 30.0688 20.3415 30.0503C24.6747 28.4438 27.5865 24.2636 27.5865 19.6481V13.7085C27.5865 13.5094 27.4569 13.3335 27.2717 13.2687L20.3274 10.954C20.2302 10.9216 20.1284 10.9216 20.0358 10.954H20.0315ZM26.6609 14.0418V19.6481C26.6609 23.8239 24.0638 27.606 20.1797 29.12C16.2957 27.6061 13.6985 23.8192 13.6985 19.6481V14.0418L20.1797 11.8799L26.6609 14.0418Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2676 19.6294C17.0871 19.4489 16.7954 19.4489 16.6149 19.6294C16.4344 19.81 16.4343 20.1017 16.6149 20.2822L19.1935 22.8608C19.2814 22.9487 19.3972 22.995 19.5222 22.995H19.5499C19.6842 22.9858 19.8046 22.9209 19.8879 22.8191L23.7905 17.8241C23.9479 17.6204 23.9109 17.3334 23.7118 17.176C23.5081 17.0186 23.2211 17.0556 23.0637 17.2547L19.4852 21.8378L17.277 19.6296L17.2676 19.6294Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2489_10491",
    x1: 38.3071,
    y1: 19.3657,
    x2: 0.0505809,
    y2: 19.4216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D659B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C99AA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScIcon2);
export default __webpack_public_path__ + "static/media/sc-icon-2.8e36a071dc359c9842b019a4812b67b4.svg";
export { ForwardRef as ReactComponent };